'use client';

import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { Search } from '@zoomit/icons';
import { Box } from '@zoomit/primitives';
import { useMenuContext } from '@zoomit/web-kit';
import { cssVar, Input, theme } from '@zoomit/zoomit-ds';

import { LightColors } from '../../constants/colors';

const StickySearch = () => {
  const menuContext = useMenuContext();

  const navigate = useNavigate();
  return (
    <Box
      className={'border-b-black5 shadow-main sticky top-[58] z-20 border-b'}
      spacing={{ px: 'x4', py: 'x2' }}
      backgroundColor={cssVar(theme.background2)}
    >
      <Input
        onClick={() => {
          menuContext?.mobileMenuTriggerState.open();
          navigate('/search');
        }}
        variant="rounded"
        placeholder="دنبال چه محصولی می‌گردی؟"
        rightNode={
          <IconWrapper>
            <Search />
          </IconWrapper>
        }
      />
    </Box>
  );
};

export default StickySearch;

const IconWrapper = styled.div`
  width: 2.4rem;
  height: 2.4rem;
  border-radius: var(${theme.radius.full});
  display: grid;
  place-items: center;
  background-color: ${cssVar(theme.primary3)};

  & svg {
    fill: ${LightColors.white};
  }
`;
